import axios from "axios";

const HOST_API = process.env.REACT_APP_URL;

export const forgotPassword = (usuarioOEmail) =>
  axios.post(`${HOST_API}api/passwordReset/ForgotPassword`, { usuarioOEmail });

export const resetPassword = (token, nuevaPassword) =>
  axios.post(`${HOST_API}api/passwordReset/ResetPassword`, { token, nuevaPassword });
